import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { apiKey } from "../../../config/config";
import { languageHelper } from "../../../config/helperFunctions";

function EditOrderType() {
    const user = JSON.parse(localStorage.getItem("rms-admin"));
    const { id } = useParams();
    const [formData, setFormData] = useState({
        name: "",
        name_ar: "",
        prefix: ""
    });
    const [loading, setLoading] = useState(false);
    const [pageLoading, setPageLoading] = useState(true);

    const navigate = useNavigate();

    const handleChange = (e) =>
        setFormData({ ...formData, [e.target.name]: e.target.value });

    const handleSubmit = (e) => {
        e.preventDefault();

        setLoading(true);
        axios
            .put(
                `${apiKey}/api/rms/admin/ordertype/${id}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
            .then((res) => {
                toast.success(
                    res.data.message || "Successfully updated order type"
                );
                navigate(-1);
            })
            .catch((err) => {
                toast.error(
                    err.response?.data?.message || "Failed to update order type"
                );
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        axios
            .get(
                `${apiKey}/api/rms/admin/ordertype/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${user?.token}`,
                    },
                }
            )
            .then((res) => {
                setFormData(res.data)
            })
            .catch((err) => {
                toast.error("Failed to fetch data");
            })
            .finally(() => setPageLoading(false));
    }, [id, user?.token]);

    if (pageLoading) {
        return (
            <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
                <img src="/assets/gif/dash2.gif" alt="" />
            </div>
        );
    }

    return (
        <main>
            <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-d-bg-text text-2xl">{languageHelper("Edit Order Type")}</h1>
                </div>
                <div className="w-full">
                    <form action="" className="w-full" onSubmit={handleSubmit}>
                        <div className="grid grid-cols-3 gap-4">
                            <label htmlFor="" className="w-full">
                                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                                    {languageHelper("Name")}
                                </span>
                                <div className="mb-2 pt-0">
                                    <input
                                        type="text"
                                        name="name"
                                        onChange={handleChange}
                                        value={formData.name}
                                        placeholder={languageHelper("Name")}
                                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                                        required
                                    />
                                </div>
                            </label>
                            <label htmlFor="" className="w-full">
                                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                                    {languageHelper("Name Arabic")}
                                </span>
                                <div className="mb-2 pt-0">
                                    <input
                                        type="text"
                                        name="name_ar"
                                        onChange={handleChange}
                                        value={formData.name_ar}
                                        placeholder={languageHelper("Name Arabic")}
                                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                                        required
                                    />
                                </div>
                            </label>
                            <label htmlFor="" className="w-full">
                                <span className="text-d-bg-text text-sm mb-2 relative before:content-['*'] before:text-red-500 before:absolute before:top-0 before:right-0 before:translate-x-2 font-bold">
                                    {languageHelper("Prefix")}
                                </span>
                                <div className="mb-2 pt-0">
                                    <input
                                        type="text"
                                        name="prefix"
                                        onChange={handleChange}
                                        value={formData.prefix}
                                        placeholder={languageHelper("Prefix")}
                                        className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                                        required
                                    />
                                </div>
                            </label>
                        </div>
                        <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
                        <div className="flex gap-2">
                            <button
                                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                                type="submit"
                            >
                                {loading && (
                                    <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                                        <img
                                            className="w-4 mx-auto"
                                            src="/assets/gif/button_loader.gif"
                                            alt=""
                                        />
                                    </span>
                                )}
                                {languageHelper("Submit")}
                            </button>
                            <button
                                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                                type="button"
                                onClick={() => navigate(-1)}
                            >
                                {languageHelper("Back")}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </main>
    );
}

export default EditOrderType;